import { useCallback, useEffect, useRef, useState } from 'react';

function getOnlineStatus(): boolean {
    return typeof navigator === 'undefined' ? true : navigator.onLine;
}

function useOnlineStatus(onStatusChange?: (isOnline: boolean) => void): {
    isOnline: boolean;
    refreshRequired: boolean;
    setRefreshRequired: (value: boolean) => void;
} {
    const [isOnline, setIsOnline] = useState(getOnlineStatus);
    const [refreshRequired, setRefreshRequiredState] = useState(false);
    const previousStatusRef = useRef(getOnlineStatus());

    const setRefreshRequired = useCallback((value: boolean) => {
        setRefreshRequiredState(value);
        (globalThis as typeof globalThis & { updateRequired?: boolean }).updateRequired = value;
    }, []);

    useEffect(() => {
        const handleOnline = () => {
            debugger;
            setIsOnline(true);
        }
        const handleOffline = () => {
            debugger;
            setIsOnline(false);
        }

        window.addEventListener('online', handleOnline);
        window.addEventListener('offline', handleOffline);

        return () => {
            window.removeEventListener('online', handleOnline);
            window.removeEventListener('offline', handleOffline);
        };
    }, []);

    useEffect(() => {
        if (previousStatusRef.current !== isOnline) {
            previousStatusRef.current = isOnline;
            onStatusChange?.(isOnline);
        }
    }, [isOnline, onStatusChange]);

    return {
        isOnline,
        refreshRequired,
        setRefreshRequired,
    };
}

export default useOnlineStatus;
